import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { DataSourcesReducerState } from "./types";
import {
  isDataSourcesFetching,
  isDataSourcesStateFetching,
  isDataSourceStateFetching,
  receiveDataSource,
  receiveDataSources,
  receiveDataSourcesState,
  updateDataSourceState,
} from "./actionCreators";
import dataSourcesByIdReducer from "./subreducers/byIdReducer";

const initialState: DataSourcesReducerState = {
  byId: {},
  isFetching: false,
  isStateFetching: false,
};

const dataSourcesReducer = reducer(
  initialState,
  on(
    ...union(
      receiveDataSources,
      receiveDataSource,
      receiveDataSourcesState,
      updateDataSourceState,
      isDataSourceStateFetching
    ),
    (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.byId = dataSourcesByIdReducer(state.byId, action);
    }
  ),
  on(isDataSourcesFetching, (state, { payload: { flag } }) => {
    // eslint-disable-next-line no-param-reassign
    state.isFetching = flag;
  }),
  on(isDataSourcesStateFetching, (state, { payload: { flag } }) => {
    // eslint-disable-next-line no-param-reassign
    state.isStateFetching = flag;
  })
);

export default dataSourcesReducer;
